import React, { useCallback } from 'react'
import styles from './DITconstructor.module.scss'
import cn from 'classnames'
import RGL, { WidthProvider } from 'react-grid-layout'
import './DITConstructor.css'
import {
  ConstructorItemProps,
  ConstructorLayoutItem,
} from '@/components/Organisms/DIT/types'
import { useActions, useAppSelector } from '@/hooks'
import { ditSliceSelectors } from '@/components/Organisms/DIT/store'
const ReactGridLayout = WidthProvider(RGL)
interface Props {
  constructorLayout: ConstructorLayoutItem[]
  handleConstructorLayout: (layout: ConstructorLayoutItem[]) => void
  constructorStyles: ConstructorItemProps[]
  width: number
  height: number
}
const DITConstructor = ({
  constructorLayout,
  handleConstructorLayout,
  constructorStyles,
  width,
  height,
}: Props) => {
  const { ditSetUnsavedChanges } = useActions()
  const [zoom, setZoom] = React.useState(1)
  const [showResize, setShowResize] = React.useState(false)
  const wrapperRef = React.useRef<HTMLDivElement | null>(null)
  const handleLayoutChange = (layout: ConstructorLayoutItem[]) => {
    handleConstructorLayout([...layout])
  }
  const onDragStop = (layout: ConstructorLayoutItem[]) => {
    // here somehow save proportions
    layout.forEach((item) => {
      if (item.maxH && item.h + item.y > item.maxH) {
        item.y = item.maxH - item.h
      }
    })
    handleLayoutChange(layout)
  }
  const activeSlideItem = useAppSelector(
    ditSliceSelectors.stateDitActiveSlideItem
  )
  const handleResize = useCallback(
    (
      l: any,
      oldLayoutItem: any,
      layoutItem: any,
      placeholder: any,
      e: MouseEvent,
      el: any
    ) => {
      if (e && e.shiftKey) {
        const heightDiff = layoutItem.h - oldLayoutItem.h
        const widthDiff = layoutItem.w - oldLayoutItem.w
        const changeCoef = oldLayoutItem.w / oldLayoutItem.h
        if (Math.abs(heightDiff) < Math.abs(widthDiff)) {
          layoutItem.h = layoutItem.w / changeCoef
          placeholder.h = layoutItem.w / changeCoef
        } else {
          layoutItem.w = layoutItem.h * changeCoef
          placeholder.w = layoutItem.h * changeCoef
        }

        el.parentElement.style.width = layoutItem.w + 'px'
        el.parentElement.style.height = layoutItem.h + 'px'
      }
      ditSetUnsavedChanges(true)
    },
    []
  )

  const handleAnyChanges = () => {
    ditSetUnsavedChanges(true)
  }

  const getMaxDitZoom = (containerSize: number): number => {
    const result = Math.floor(containerSize / width)
    return result > 4 ? 4 : result
  }
  React.useLayoutEffect(() => {
    if (wrapperRef.current) {
      const newZoom = getMaxDitZoom(wrapperRef.current?.offsetWidth)
      if (zoom !== newZoom) {
        setZoom(newZoom)
      }
    }
  }, [])
  return (
    <>
      <div
        className={styles.GridWrapper}
        style={{
          height: `${height * zoom}px`,
          // marginLeft: `${zoom > 1 ? (width / 2) * (zoom - 1) : 0}px`,
          // marginTop: `${zoom > 1 ? (height / 2) * (zoom - 1) + 20 : 0}px`,
        }}
        ref={wrapperRef}
      >
        {/*<p>*/}
        {/*  DIT size: w{width}, h{height}. Zoom: {zoom}*/}
        {/*  <p>{(width / 2) * (zoom - 1)}</p>*/}
        {/*</p>*/}

        <ReactGridLayout
          style={{
            height: height,
            width: width,
            // zoom: `${zoom}00%`,
            transform: `scale(${zoom})`,
            boxShadow: `0 0 0 ${1 / zoom}px deepskyblue`,
            transformOrigin: 'top left',
          }}
          onLayoutChange={handleLayoutChange}
          onDragStop={onDragStop}
          onResizeStop={onDragStop}
          onDrag={handleAnyChanges}
          onResize={handleResize}
          useCSSTransforms={true}
          allowOverlap={true}
          // isDraggable={true}
          isResizable={true}
          layout={constructorLayout}
          rowHeight={1}
          cols={width}
          // autoSize={true}
          // Experiments
          transformScale={zoom}
          containerPadding={[0, 0]}
          margin={[0, 0]}
          resizeHandles={['se']}
        >
          {constructorLayout.map((item, index) => {
            const current = constructorStyles.find(
              (cur) => String(cur.id) === item.i
            )
            if (!current) return null
            const isText = current.type === 'text'
            let itemStyle = {}
            if (isText) {
              itemStyle = {
                fontStyle: current.fontStyle,
                textDecoration: current.textDecoration,
                fontWeight: current.fontWeight === 'normal' ? 400 : 700,
                fontSize: `${current.fontSize}px`,
                textAlign: current.textAlign,
                color: current.color,
                zIndex: index,
                width: '100%',
                maxHeight: '100%',
              }
            }

            return (
              <div
                key={item.i}
                className={cn(styles.Item, {
                  [styles.ActiveItem]: item.i === String(activeSlideItem),
                })}
              >
                {isText ? (
                  <p style={itemStyle}>{current.text}</p>
                ) : (
                  <div className={styles.imgWrapper}>
                    <img
                      className={styles.ItemImage}
                      src={current.imageUrl || ''}
                      loading={'lazy'}
                    />
                  </div>
                )}
              </div>
            )
          })}
        </ReactGridLayout>
      </div>
    </>
  )
}

export default DITConstructor
